import { name } from "file-loader";
import App from "../App";
// import questions from "../page/qa/questions"
// const questions = r => require.ensure([], () => r(require("../page/qa/questions")), 'questions')
const questions = () =>
  import(/* webpackChunkName: "group-qa" */ "../page/qa/questions");
const ask = () => import(/* webpackChunkName: "group-qa" */ "../page/qa/ask");
const answer = () =>
  import(/* webpackChunkName: "group-qa" */ "../page/qa/answer");
const seeQuestion = () =>
  import(/* webpackChunkName: "group-qa" */ "../page/qa/seeQuestion");
const myAnswers = () =>
  import(/* webpackChunkName: "group-qa" */ "../page/qa/myAnswers");
const myQuestions = () =>
  import(/* webpackChunkName: "group-qa" */ "../page/qa/myQuestions");
const myQA = () => import(/* webpackChunkName: "group-qa" */ "../page/qa/myQA");

// 切换货币
const changeCurrency = () =>
  import(
    /* webpackChunkName: "group-currency" */ "../page/setting/changeCurrency"
  );
const couponActivity = () =>
  import(
    /* webpackChunkName: "group-currency" */ "../page/activity/coupon_activity"
  );
const couponActivity1 = () =>
  import(
    /* webpackChunkName: "group-currency" */ "../page/activity/coupon_activity1"
  );
  
const mine = () =>
  import(/* webpackChunkName: "group-currency" */ "../page/mine/mine");
const changeLanguage = () =>
  import(
    /* webpackChunkName: "group-currency" */ "../page/setting/changeLanguage"
  );

const icbcPay = () =>
  import(/* webpackChunkName: "group-currency" */ "../page/icbcPay/icbcPay");

const orderSuccess = () =>
  import(
    /* webpackChunkName: "group-currency" */ "../page/shopOrder/orderSuccess"
  );
const orderSuccessConsumer = () =>
  import(
    /* webpackChunkName: "group-currency" */ "../page/shopOrder/orderSuccessConsumer"
  );
const commodityItemActiveUrl = () =>
  import(
    /* webpackChunkName: "group-currency" */ "../page/macaushop/commodityItemActiveUrl"
  );
const webActiveUrl = () =>
  import(
    /* webpackChunkName: "group-currency" */ "../page/macaushop/webActiveUrl"
  );

// import activate from "../page/card/activate"
const activate = r =>
  require.ensure([], () => r(require("../page/card/activate")), "activate");
// import home from '../page/home/home'
// import macaushop from "../page/macaushop/macaushop.vue"
const macaushop = r =>
  require.ensure(
    [],
    () => r(require("../page/macaushop/macaushop")),
    "macaushop"
  );
// import macauItemList from "../page/macaushop/macauItemList"
// import macauItemStartList from "../page/macaushop/macauItemStartList"
// import macauItemBigList from "../page/macaushop/macauItemBigList"
// import macauDoubleItemList from "../page/macaushop/macauDoubleItemList"
// import macauItemHTML from "../page/macaushop/macauItemHTML"
const macauItemHTML = r =>
  require.ensure(
    [],
    () => r(require("../page/macaushop/macauItemHTML")),
    "macauItemHTML"
  );
// import login from "../page/login/login"
const login = r =>
  require.ensure([], () => r(require("../page/login/login")), "login");
// import newMacauShop from "../page/macaushop/new_macauShop"

const commodityList = r =>
  require.ensure(
    [],
    () => r(require("../page/macaushop/commodityList")),
    "commodityList"
  );

// import couponPromotion from "../page/coupon/couponPromotion"
const couponPromotion = r =>
  require.ensure(
    [],
    () => r(require("../page/coupon/couponPromotion")),
    "couponPromotion"
  );
// import couponPromotionItem from "../page/coupon/couponPromotionItem"
const couponPromotionItem = r =>
  require.ensure(
    [],
    () => r(require("../page/coupon/couponPromotionItem")),
    "couponPromotionItem"
  );
// import myCouponList from "../page/coupon/myCouponList"
const myCouponList = r =>
  require.ensure(
    [],
    () => r(require("../page/coupon/myCouponList")),
    "myCouponList"
  );
  const MineCouponList = r =>
  require.ensure(
    [],
    () => r(require("../page/coupon/MineCouponList")),
    "MineCouponList"
  );
  const FullScreenScanner = r =>
  require.ensure(
    [],
    () => r(require("../page/coupon/FullScreenScanner")),
    "FullScreenScanner"
  );
   const consumer_coupon_item = r =>
  require.ensure(
    [],
    () => r(require("../page/coupon/consumer_coupon_item")),
    "consumer_coupon_item"
  );
// import myCouponBagItem from "../page/coupon/myCouponBagItem"
const myCouponBagItem = r =>
  require.ensure(
    [],
    () => r(require("../page/coupon/myCouponBagItem")),
    "myCouponBagItem"
  );

// import author from "../page/author.vue"
const author = r =>
  require.ensure([], () => r(require("../page/author")), "author");

// import wbauthor from "../page/wbauthor.vue"
const minepage = r =>
  require.ensure([], () => r(require("../page/home/minepage")), "minepage");
// import minepage from "../page/home/minepage.vue"
// import store from '../store'
const shareforflowing = r =>
  require.ensure(
    [],
    () => r(require("../page/activity/shareforflowing")),
    "shareforflowing"
  );
// import shareforflowing from '../page/activity/shareforflowing'
const activityflowing = r =>
  require.ensure(
    [],
    () => r(require("../page/activity/activityflowing")),
    "activityflowing"
  );
// import activityflowing from '../page/activity/activityflowing'
const siufay = r =>
  require.ensure([], () => r(require("../page/activity/siufay")), "siufay");
// 商城
const shophome = r =>
  require.ensure([], () => r(require("../page/home/shophome")), "shophome");
// import shophome from '../page/home/shophome'
const findmcshoplist = r =>
  require.ensure(
    [],
    () => r(require("../page/macaushop/findmcShopList")),
    "findmcshoplist"
  );
// import findmcshoplist from '../page/macaushop/findmcShopList.vue'

const commodityItem = r =>
  require.ensure(
    [],
    () => r(require("../page/macaushop/commodityItem.vue")),
    "commodityItem"
  );

const orderPage = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/orderPage")),
    "orderPage"
  );

  const orderOption = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/orderOption")),
    "orderOption"
  );

  const orderOptionNext = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/orderOptionNext")),
    "orderOptionNext"
  );
  const pickleballSelect = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/pickleballSelect")),
    "pickleballSelect"
  );
  const pdfController = r =>
    require.ensure(
      [],
      () => r(require("../page/v2/pdf-signature/pdf-signature")),
      "signature"
    );

  const orderSubmit = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/orderSubmit")),
    "orderSubmit"
  );
  const orderSubmitConsumer = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/orderSubmitConsumer")),
    "orderSubmitConsumer"
  );
  const orderSubmitDirect = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/orderSubmitDirect")),
    "orderSubmitDirect"
  );

const orderPayFinished = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/orderPayFinished")),
    "orderPayFinished"
  );
const myOrderList = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/myOrderList")),
    "myOrderList"
  );
  const myOrderListConsumer = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/myOrderListConsumer")),
    "myOrderListConsumer"
  );
const orderItem = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/orderItem")),
    "orderItem"
  );
  const orderItemConsumer = r =>
  require.ensure(
    [],
    () => r(require("../page/shopOrder/orderItemConsumer")),
    "orderItemConsumer"
  );
const selectAcivities = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/SelectActivities.vue")),
    "selectAcivities"
  );

// import commodityItem from '../page/macaushop/commodityItem.vue'
// import orderPage from '../page/shopOrder/orderPage.vue'
// import myOrderList from '../page/shopOrder/myOrderList.vue'
// import orderItem from '../page/shopOrder/orderItem.vue'
/*  beforeRouteLeave (to, from, next) {
        if(store.currentPage==''){console.log('离开导航组件')}
        next()
      },
  */

// 酒店路由
const hotel = () =>
  import(/* webpackChunkName: "group-hotel" */ "../page/hotel/hotel");
// 酒店列表路由
const hotelList = () =>
  import(/* webpackChunkName: "group-hotel" */ "../page/hotel/hotelListNew");
const hotelSearch = () =>
  import(/* webpackChunkName: "group-hotel" */ "../page/hotel/hotelSearch");
// 酒店预订页面路由
const booking = () =>
  import(/* webpackChunkName: "group-hotel" */ "../page/hotel/booking");
// 酒店详情路由
const hotelDetail = () =>
  import(/* webpackChunkName: "group-hotel" */ "../page/hotel/hotelDetail");

// 日历路由
const calendar = () =>
  import(/* webpackChunkName: "group-hotel" */ "../page/calendar/calendar");

// 线下支付
const underline = () =>
  import(/* webpackChunkName: "group-hotel" */ "../page/underline/underline");

// 高德地图
const amap = () =>
  import(/* webpackChunkName: "group-hotel" */ "../page/hotel/HotelMap");
// 凯斯哈林连连看
const haring = r =>
  require.ensure(
    [],
    () => r(require("../page/linkgame/KeithHaring")),
    "haring"
  );

// 官前街连连看
const tour = r =>
  require.ensure([], () => r(require("../page/gqjgame/tour")), "tour");

const appointment = r =>
  require.ensure(
    [],
    () => r(require("../page/activity/appointment")),
    "appointment"
  );

const venue = r =>
  require.ensure([], () => r(require("../page/activity/venue")), "venue");

const activityFlowDistribution = r =>
  require.ensure(
    [],
    () => r(require("../page/activity/activityFlowDistribution")),
    "activityFlowDistribution"
  );

const activityTransactionDetail = r =>
  require.ensure(
    [],
    () => r(require("../page/activity/activityTransactionDetail")),
    "activityTransactionDetail"
  );

const activityStatistic = r =>
  require.ensure(
    [],
    () => r(require("../page/activity/activityStatistic")),
    "activityStatistic"
  );

// 邀请链接
const invication = r =>
  require.ensure(
    [],
    () => r(require("../page/activity/invication")),
    "invication"
  );

// 邀请有奖
const inviteCode = r =>
  require.ensure(
    [],
    () => r(require("../page/invitation/myInvitation.vue")),
    "inviteCode"
  );
const invitePrize = r =>
  require.ensure(
    [],
    () => r(require("../page/invitation/invitationPrize.vue")),
    "invitePrize"
  );

// 积分有奖
const integral = r =>
  require.ensure([], () => r(require("../page/mine/integral.vue")), "integral");
// const invitePrize = () => import(/* webpackChunkName: "group-hotel" */ '../page/invitation/myInvitation')

// 发布评论
const commodityReview = r =>
  require.ensure(
    [],
    () => r(require("../page/review/commodity_review.vue")),
    "commodityReview"
  );
const commodityReviewList = r =>
  require.ensure(
    [],
    () => r(require("../page/review/commodity_review_list.vue")),
    "commodityReviewList"
  );

// 目的地列表路由
const destination = r =>
  require.ensure(
    [],
    () => r(require("../page/home/destination.vue")),
    "destination"
  );

// 酒店推薦更多頁面路由
const RecomendMore = r =>
  require.ensure(
    [],
    () => r(require("../page/hotel/RecomendMore.vue")),
    "RecomendMore"
  );

// 全局收搜頁面路由
const GlobalSearch = r =>
  require.ensure(
    [],
    () => r(require("../page/home/globalSearch.vue")),
    "globalSearch"
  );
// 全局收搜更多頁面路由
const GlobalSearchMore = r =>
  require.ensure(
    [],
    () => r(require("../page/home/globalSearchMore.vue")),
    "globalSearch"
  );

const main = r =>
  require.ensure([], () => r(require("../page/v2/Main.vue")), "main");

const deliveryAddress = r =>
  require.ensure(
    [],
    () => r(require("../page/mine/deliveryAddress/deliveryAddress.vue")),
    "main"
  );
const travelAddress = r =>
  require.ensure(
    [],
    () => r(require("../page/mine/travelAddress.vue")),
    "main"
  );
const activityMain = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/activityCate/activityCatePage.vue")),
    "activityCatePage"
  );

const noveltyDetail = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/novelty/noveltyDetail.vue")),
    "noveltyDetail"
  );

const videoDetail = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/novelty/videoDetail.vue")),
    "videoDetail"
  );

const reviewList = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/novelty/reviewList.vue")),
    "reviewList"
  );

const activityCateModule = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/activityModule/activityModule.vue")),
    "activityModule"
  );

const homeGoodModuleList = r =>
  require.ensure(
    [],
    () =>
      r(require("../page/v2/Tabbar/homecommonTemplate/homeGoodModuleList.vue")),
    "homeGoodModuleList"
  );

const activitydetailwb = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/activityDetail/activitydetail.vue")),
    "activitydetail"
  );

const CityGongLv = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/CityCateGongLv/CityGongLv.vue")),
    "CityGongLv"
  );

const gongLvFeature = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/GongLV/feature.vue")),
    "feature"
  );

const Contact = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/Mine/Contact.vue")),
    "Contact"
  );

const gongLvDetailvc = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/WebView/webView.vue")),
    "webView"
  );

const personInfo = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/PersonInfo/personInfo.vue")),
    "personInfo"
  );

const FMBindAccount = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/PersonInfo/FMBindAccount.vue")),
    "FMBindAccount"
  );

const FMLogoutChecking = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/PersonInfo/FMLogoutChecking.vue")),
    "FMLogoutChecking"
  );

const FMSureCancellation = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/PersonInfo/FMSureCancellation.vue")),
    "FMSureCancellation"
  );

const FMCancellationAccount = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/PersonInfo/FMCancellationAccount.vue")),
    "FMCancellationAccount"
  );

const transitionPage = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/transitionPage/transitionPage.vue")),
    "transitionPage"
  );
const ballot1 = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/tdm/Ballot1.vue")),
    "ballot1"
  );
const ballot2 = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/tdm/Ballot2.vue")),
    "ballot2"
  );
const ballot3 = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/tdm/Ballot3.vue")),
    "ballot3"
  );
// 抽奖路由

const prizeward = () =>
  import(/* webpackChunkName: "prizeward" */ "../page/prizeward/prizeward.vue");

const test = () =>
  import(/* webpackChunkName: "prizeward" */ "../page/prizeward/test.vue");

const poster = () =>
  import(/* webpackChunkName: "prizeward" */ "../page/prizeward/poster.vue");
// 抽奖路由

const travel = () =>
  import(/* webpackChunkName: "prizeward" */ "../page/travel/travel.vue");

const cultural = () =>
  import(/* webpackChunkName: "prizeward" */ "../page/cultural/cultural.vue");

//中小企业优惠信息路由
const FMapplicationform = () =>
  import(
    /* webpackChunkName: "prizeward" */ "../page/FMapplicationform/FMapplicationform.vue"
  );

//投票
const vote = () =>
  import(/* webpackChunkName: "prizeward" */ "../page/vote/vote.vue");

const voteresult = () =>
  import(/* webpackChunkName: "prizeward" */ "../page/vote/voteresult.vue");

const SaleDetail = () =>
  import(
    /* webpackChunkName: "prizeward" */ "../page/SaleDetail/SaleDetail.vue"
  );

const SaleStatistics = () =>
  import(
    /* webpackChunkName: "prizeward" */ "../page/SaleDetail/SaleStatistics.vue"
  );

const merchantJoin = () =>
  import(/* webpackChunkName: "merchantJoin" */ "../page/merchant/join.vue");

const merchantJoinPlatform = () =>
  import(
    /* webpackChunkName: "merchantJoin" */ "../page/merchant/merchantJoin.vue"
  );

const toExamine = () =>
  import(/* webpackChunkName: "toExamine" */ "../page/merchant/toExamine.vue");

const BussinessIncome = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/merchant/BussinessIncome.vue"
  );

const BussinessIncomeInfo = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/merchant/BussinessIncomeInfo.vue"
  );

const PayRecords = () =>
  import(/* webpackChunkName: "toExamine" */ "../page/merchant/PayRecords.vue");

const PayRecordTotal = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/merchant/PayRecordTotal.vue"
  );

const settlement = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/merchant/BussinessSettlement.vue"
  );

const StaffManger = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/merchant/StaffManger.vue"
  );

const BussinessInfo = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/merchant/BussinessInfo.vue"
  );
const PaymentDetails = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/merchant/PaymentDetails.vue"
  );

const qrcodepay = () =>
  import(/* webpackChunkName: "qrcodepay" */ "../page/qrcodepay/qrcodepay.vue");

const paysuccess = () =>
  import(
    /* webpackChunkName: "qrcodepay" */ "../page/qrcodepay/PaySuccessViewController.vue"
  );

const testxcx = () =>
  import(/* webpackChunkName: "qrcodepay" */ "../page/qrcodepay/testxcx.vue");

const qrcodepaySuccess = () =>
  import(
    /* webpackChunkName: "qrcodepay" */ "../page/qrcodepay/qrcodepaySuccess.vue"
  );

const BussinessNumber = () =>
  import(
    /* webpackChunkName: "qrcodepay" */ "../page/merchant/BussinessNumber.vue"
  );

const Newjoin = () =>
  import(/* webpackChunkName: "toExamine" */ "../page/merchant/Newjoin.vue");

const marketHome = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/51 mart/home/marketHome.vue"
  );
const marketPaymentRecords = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/51 mart/home/marketPaymentRecords.vue"
  );
const marketOrderList = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/51 mart/home/marketOrderList.vue"
  );

const marketActivityList = () =>
  import("../page/51 mart/home/marketActivityList.vue");

const marketCommission = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/51 mart/home/marketCommission.vue"
  );


const shipDailySalesRecord = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/51 mart/home/shipDailySalesRecord.vue"
  );

const commissionSubsidiary = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/51 mart/home/commissionSubsidiary.vue"
  );

const marketSoldDetail = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/51 mart/home/marketSoldDetail.vue"
  );

const payRecordEveryDayDetail = () =>
  import(
    /* webpackChunkName: "qrcodepay" */ "../page/merchant/payRecordEveryDayDetail.vue"
  );
const verified = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/51 mart/home/Verified.vue"
  );
const notVerified = () =>
  import(
    /* webpackChunkName: "toExamine" */ "../page/51 mart/home/NotVerified.vue"
  );
const wxQrcodeReader = r =>
  require.ensure(
    [],
    () => r(require("../page/v2/Tabbar/VerificationCode/wxQrcodeReader.vue")),
    "wxQrcodeReader"
  );

  const paymentTransition = r =>
    require.ensure(
      [],
      () => r(require("../page/shopOrder/paymentTransition/paymentTransition.vue")),
      "paymentTransition"
    );

    const orderBocWebView = r =>
      require.ensure(
        [],
        () => r(require("../page/shopOrder/orderBoc/orderBocWebView.vue")),
        "orderBocWebView"
      );
export default [
  {
    path: "/",
    component: App, // 顶层路由，对应index.html
    children: [
      // 二级路由。对应App.vue
      // 地址为空时跳转home页面
      {
        path: "",
        name: "findmacau",
        redirect: "/home"
        // redirect: '/coupon_promotion'
      },
      {
        path: "/tick",
        name: "findmacau",
        redirect: "/shopping"
        // redirect: '/coupon_promotion'
      },
      {
        path: "/",

        component: main,
        redirect: '/home',
        children: [
          {
            path: 'home',
            name: 'home',
            component: () => import('@/page/v2/Tabbar/Home'),
            meta: { 
              keepAlive: true,
              isBack: false,
              tabbarIndex: 0 
            }
          },
          {
            path: 'shopping',
            name: 'shopping',
            component: () => import('@/page/v2/Tabbar/ShopNew'),
            meta: { tabbarIndex: 1 }
          },
          {
            path: 'citythings',
            name: 'citythings',
            component: () => import('@/page/v2/Tabbar/CityThings'),
            meta: { 
              keepAlive: true,
              isBack: false,
              tabbarIndex: 2 
            }
          },
          {
            path: 'my',
            name: 'my',
            component: () => import('@/page/v2/Tabbar/My'),
            meta: { tabbarIndex: 3 }
          }
        ]
      },
   
     
      {
        path: "/prize",
        component: prizeward
      },
      {
        path: "/poster",
        component: poster
      },
      {
        path: "/test",
        component: test
      },
      {
        path: "/travel",
        component: travel
      },

      {
        path: "/vote",
        component: vote
      },
      {
        path: "/voteresult",
        component: voteresult
      },
      {
        //中小企业优惠信息
        path: "/FMapplicationform",
        component: FMapplicationform
      },
      {
        path: "/cultural",
        component: cultural
      },
      {
        //  充流量活动
        path: "/activityflowing",
        component: activityflowing
      },
      {
        // 冲流量分享页面
        path: "/shareforflowing",
        name: "shareforflowing",
        component: shareforflowing
      },
      // 我的页面
      {
        path: "minepage",
        name: "minepage",
        component: minepage
      },
      {
        path: "commodityList",
        name: "commodityList",
        component: commodityList
      },
      // 我的卡券包
      {
        // 授权页面
        path: "/author",
        name: "author",
        component: author,
        beforeEnter: (to, from, next) => {
          debugger;
          console.log(to.query);

          if (!to.query["redirect"]) {
            to.query["redirect"] = from.fullPath;
          }
          next();
        }
      },
      // {
      //   //微博授权页面
      //   path:'/wbauthor',
      //   component:wbauthor
      // },
      // 登录
      {
        path: "/login",
        name: "login",
        component: login
      },
      // 我的卡券包
      {
        path: "/my_coupon_list",
        name: "my_coupon_list",
        component: myCouponList
      },
        {
        path: "/MineCouponList",
        name: "MineCouponList",
        component: MineCouponList
      },
       {
        path: "/FullScreenScanner",
        name: "FullScreenScanner",
        component: FullScreenScanner
      },
          {
        path: "/consumer_coupon_item",
        name: "consumer_coupon_item",
        component: consumer_coupon_item
      },
      // 我的优惠券详情
      {
        path: "/my_couponbag_item",
        name: "my_couponbag_item",
        component: myCouponBagItem
      },
      // 领券中心详情
      {
        path: "/coupon_promotion_item",
        name: "coupon_promotion_item",
        component: couponPromotionItem
      },
      // 优惠券中心
      {
        path: "/coupon_promotion",
        name: "coupon_promotion",
        component: couponPromotion
      },
      // 跳转外链
      {
        path: "/macau_item_html",
        name: "macau_item_html",
        component: macauItemHTML
      },
      // FMSHOP详情
      {
        path: "/macaushop",
        name: "macaushop",
        component: macaushop
      },
      {
        path: "/deliveryAddress",
        name: "deliveryAddress",
        component: deliveryAddress
      },
      {
        path: "/travelAddress",
        name: "travelAddress",
        component: travelAddress
      },
      // 问题列表
      {
        path: "/question",
        component: questions,
        meta: {
          keepAlive: true
        }
      },
      {
        path: "/seeQ",
        component: seeQuestion
      },
      {
        path: "/ask",
        component: ask
      },
      {
        path: "/answer",
        component: answer
      },
      {
        path: "/myQA",
        component: myQA,
        children: [
          {
            path: "my_reply",
            components: {
              my: myAnswers
            }
          },
          {
            path: "my_que",
            components: {
              my: myQuestions
            }
          }
        ]
      },
      {
        path: "act",
        component: activate
      },
      {
        path: "myOrderList",
        name: "myOrderList",
        component: myOrderList
      },
          {
        path: "myOrderListConsumer",
        name: "myOrderListConsumer",
        component: myOrderListConsumer
      },
      // 订单详情
      {
        path: "orderItem",
        name: "orderItem",
        component: orderItem
      },
      {
        path: "orderItemConsumer",
        name: "orderItemConsumer",
        component: orderItemConsumer
      },
      // 订单详情
      {
        path: "orderPage",
        name: "orderPage",
        component: orderPage
      },
      {
        path: "orderOption",
        name: "orderOption",
        component: orderOption,
        meta: {
          keepAlive: false,
          isBack: false
        }
      },
       {
        path: "pickleballSelect",
        name: "pickleballSelect",
        component: pickleballSelect,
        meta: {
          keepAlive: false,
          isBack: false
        }
      },
      {
        path: "orderOptionNext",
        name: "orderOptionNext",
        component: orderOptionNext,
        meta: {
          keepAlive: false,
          isBack: false
        }
      },
      {
        path: "orderSubmit",
        name: "orderSubmit",
        component: orderSubmit
      },
      {
        path: "/orderSubmitConsumer",
        name: "orderSubmitConsumer",
        component: orderSubmitConsumer
      },
      {
        path: "orderSubmitDirect",
        name: "orderSubmitDirect",
        component: orderSubmitDirect
      },
      {
        path: "orderPayFinished",
        name: "orderPayFinished",
        component: orderPayFinished
      },
      {
        path: "findmcshoplist",
        name: "findmcshoplist",
        component: findmcshoplist,
        meta: {
          keepAlive: true,
          isBack: false
        }
      },
      {
        path: "commodityItem",
        name: "commodityItem",
        component: commodityItem
      },
      {
        path: "commodityItemActiveUrl",
        name: "commodityItemActiveUrl",
        component: commodityItemActiveUrl
      },
      {
        path: "siufay",
        name: "siufay",
        component: siufay
      },
     
      {
        path: "changeCurrency",
        name: "changeCurrency",
        component: changeCurrency
      },
      {
        path: "couponActivity",
        name: "couponActivity",
        component: couponActivity
      },
      {
        path: "mine",
        name: "mine",
        component: mine
      },
      {
        path: "changeLanguage",
        name: "changeLanguage",
        component: changeLanguage
      },
      {
        path: "couponActivity1",
        name: "couponActivity1",
        component: couponActivity1
      },
      {
        path: "icbcPay",
        name: "icbcPay",
        component: icbcPay
      },
      {
        path: "orderSuccess",
        name: "orderSuccess",
        component: orderSuccess
      },
         {
        path: "orderSuccessConsumer",
        name: "orderSuccessConsumer",
        component: orderSuccessConsumer
      },
      {
        
        path: "paymentTransition",
        name: "paymentTransition",
        component: paymentTransition
      },
      {
        path: "hotel",
        name: "hotel",
        component: hotel
      },
      {
        path: "hotelList",
        name: "hotelList",
        component: hotelList
      },
      {
        path: "hotelSearch",
        name: "hotelSearch",
        component: hotelSearch
      },
      {
        path: "booking",
        name: "booking",
        component: booking
      },
      {
        path: "hotelDetail",
        name: "hotelDetail",
        component: hotelDetail
      },
      {
        path: "calendar",
        name: "calendar",
        component: calendar
      },
      {
        path: "underline",
        name: "underline",
        component: underline
      },
      {
        path: "amap",
        name: "amap",
        component: amap
      },
      {
        path: "invitePrize",
        name: "invitePrize",
        component: invitePrize
      },
      {
        path: "inviteCode",
        name: "inviteCode",
        component: inviteCode
      },
      {
        path: "haring",
        name: "haring",
        component: haring
      },
      {
        path: "tour",
        name: "tour",
        component: tour
      },
      {
        path: "invication",
        name: "invication",
        component: invication
      },
      {
        path: "appointment",
        name: "appointment",
        component: appointment
      },
      {
        path: "venue",
        name: "venue",
        component: venue
      },
      {
        path: "activityFlowDistribution",
        name: "activityFlowDistribution",
        component: activityFlowDistribution
      },
      {
        path: "activityTransactionDetail",
        name: "activityTransactionDetail",
        component: activityTransactionDetail
      },
      {
        path: "activityStatistic",
        name: "activityStatistic",
        component: activityStatistic
      },
      {
        path: "integral",
        name: "integral",
        component: integral
      },
      {
        path: "commodityReview",
        name: "commodityReview",
        component: commodityReview
      },
      {
        path: "commodityReviewList",
        name: "commodityReviewList",
        component: commodityReviewList
      },
      {
        path: "destination",
        name: "destination",
        component: destination
      },
      {
        path: "recomendMore",
        name: "recomendMore",
        component: RecomendMore
      },
      {
        path: "globalSearch",
        name: "globalSearch",
        component: GlobalSearch
      },
      {
        path: "globalSearchMore",
        name: "globalSearchMore",
        component: GlobalSearchMore
      },
      {
        path: "webActiveUrl",
        name: "webActiveUrl",
        component: webActiveUrl
      },
      {
        path: "activityMain",
        name: "activityMain",
        component: activityMain
        // meta: {
        //   keepAlive: true,
        //   isBack: false
        // }
      },
      {
        path: "activitydetail",
        name: "activitydetail",
        component: activitydetailwb
      },
      {
        path: "strategy",
        name: "feature",
        component: gongLvFeature
        // meta: {
        //   keepAlive: true,
        //   isBack: false
        // }
      },
      {
        path: "activityModule",
        name: "activityModule",
        component: activityCateModule
      },
      {
        path: "homeGoodModuleList",
        name: "homeGoodModuleList",
        component: homeGoodModuleList
      },
      {
        path: "webView",
        name: "webView",
        component: gongLvDetailvc
      },
      {
        path: "personInfo",
        name: "personInfo",
        component: personInfo
      },
      {
        path: "FMBindAccount",
        name: "FMBindAccount",
        component: FMBindAccount
      },
      {
        path: "FMLogoutChecking",
        name: "FMLogoutChecking",
        component: FMLogoutChecking
      },
      {
        path: "FMSureCancellation",
        name: "FMSureCancellation",
        component: FMSureCancellation
      },
      {
        path: "FMCancellationAccount",
        name: "FMCancellationAccount",
        component: FMCancellationAccount
      },
      {
        path: "Contact",
        name: "Contact",
        component: Contact
      },
      {
        path: "CityGongLv",
        name: "CityGongLv",
        component: CityGongLv
      },
      {
        path: "webActiveUrl",
        name: "webActiveUrl",
        component: webActiveUrl
      },
      {
        path: "SaleDetail",
        component: SaleDetail
      },
      {
        path: "SaleStatistics",
        component: SaleStatistics
      },
      {
        path: "/join",
        component: merchantJoin,
        name: "merchantJoin",
        meta: {
          keepAlive: true,
          isBack: false
        }
      },
      {
        path: "/merchantJoin",
        component: merchantJoinPlatform
      },
      {
        path: "/toExamine",
        component: toExamine
      },
      {
        path: "/BussinessIncome",
        name:"BussinessIncome",
        component: BussinessIncome
      },
      {
        path: "/BussinessIncomeInfo",
        name:"BussinessIncomeInfo",
        component: BussinessIncomeInfo
      },

      {
        path: "/PayRecords",
        name:"PayRecords",
        component: PayRecords
      },
      {
        path: "/orderBocWebView",
        name:"orderBocWebView",
        component: orderBocWebView

      },
      {
        path: "/PayRecordTotal",
        name:"PayRecordTotal",
        component: PayRecordTotal
      },
      {
        path: "/settlement",
        name:"settlement",
        component: settlement
      },
      {
        path: "/StaffManger",
        name:"StaffManger",
        component: StaffManger
      },
      {
        path: "/BussinessInfo",
        name:"BussinessInfo",
        component: BussinessInfo
      },
      {
        path: "/PaymentDetails",
        component: PaymentDetails
      },
      {
        path: "qrcodepay",
        component: qrcodepay
      },
      {
        path: "PaySuccessViewController",
        name: "paysuccess",
        component: paysuccess
      },
      {
        path: "testxcx",
        component: testxcx
      },
      {
        path: "qrcodepaySuccess",
        component: qrcodepaySuccess
      },
      {
        path: "/BussinessNumber",
        name:"BussinessNumber",
        component: BussinessNumber
      },
      {
        path: "/Newjoin",
        component: Newjoin
      },
      {
        path: "/marketHome",
        component: marketHome
      },
      {
       
        path: "/marketPaymentRecords",
        name:"marketPaymentRecords",
        component: marketPaymentRecords
      },
      {
        path: "/marketOrderList",
        component: marketOrderList
      },
      {
        path: "/marketActivityList",
        component: marketActivityList
      },
      {
        path: "/marketCommission",
        name:"marketCommission",
        component: marketCommission
      },
      {
        path: "/shipDailySalesRecord",
        component: shipDailySalesRecord
      },
      {
        path: "/commissionSubsidiary",
        name:"commissionSubsidiary",
        component: commissionSubsidiary
      },
      {
        path: "/marketSoldDetail",
        name:"marketSoldDetail",
        component: marketSoldDetail
      },
      {
        path: "/payRecordEveryDayDetail",
        component: payRecordEveryDayDetail
      },
      {
        path: "/transitionPage",
        name: "transitionPage",
        component: transitionPage
      },
      {
        path: "/noveltyDetail",
        name: "noveltyDetail",
        component: noveltyDetail
      },
      {
        path: "/reviewList",
        name: "reviewList",
        component: reviewList
      },
      {
        path: "/videoDetail",
        name: "videoDetail",
        component: videoDetail
      },
      {
        path: "/ballot1",
        name: "ballot1",
        component: ballot1
      },
      {
        path: "/ballot2",
        name: "ballot2",
        component: ballot2
      },
      {
        path: "/ballot3",
        name: "ballot3",
        component: ballot3
      },
      {
        path: "/wxQrcodeReader",
        name: "wxQrcodeReader",
        component: wxQrcodeReader
      },
      {
        path: "/verified",
        name: "verified",
        component: verified
      },
      {
        path: "/notVerified",
        name: "notVerified",
        component: notVerified
      },
      {
        path: "selectAcivities",
        name: "selectAcivities",
        component: selectAcivities
      },
      {
        
        path: "pdfController",
        name: "pdfController",
        component: pdfController
      },
      {
        //秒支付订单视图 - 重定向到 orderSubmitDirect
        path: "SeckillPayOrderView",
        name: "SeckillPayOrderView",
        redirect: "/orderSubmitDirect"
      }
    ]
  }
];






// WEBPACK FOOTER //
// ./src/router/router.js